import { render, staticRenderFns } from "./new-invoice.vue?vue&type=template&id=b78f0b88&scoped=true"
import script from "./new-invoice.vue?vue&type=script&lang=js"
export * from "./new-invoice.vue?vue&type=script&lang=js"
import style0 from "./new-invoice.vue?vue&type=style&index=0&id=b78f0b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78f0b88",
  null
  
)

export default component.exports